import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anonKey) {
  // 起動時に欠落していたら早めにダッシュボードで気付けるように throw する
  // (Cloudflare Pages の env 設定漏れの典型ミス)
  throw new Error(
    'Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. ' +
      'Set them in .env (local) or Cloudflare Pages > Settings > Environment variables (deployed).'
  )
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
})

export type Liver = {
  id: string
  line_user_id: string | null
  display_name: string
  avatar_url: string | null
  status: 'active' | 'inactive' | 'graduated'
  joined_at: string | null
  left_at: string | null
  notes: string | null
  created_at: string
  updated_at: string
}

export type Manager = {
  id: string
  user_id: string | null
  email: string
  name: string | null
  department: string | null
  role: 'admin' | 'manager'
  hired_at: string | null
  left_at: string | null
  created_at: string
  updated_at: string
}
